(function ($, Modernizer, Drupal) {
  'use strict';

  Drupal.behaviors.images = {
    attach: function (context, settings) {
      if (!Modernizr.objectfit) {
        $('.teaser-image__container', context).each(function () {
          const $container = $(this);
          const imgUrl = $container.find('img').prop('src');

          if (imgUrl) {
            $container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('teaser-image__fallback');
          }
        });
      }
    }
  };
})(jQuery, Modernizr, Drupal);
